module.exports = __webpack_public_path__ + "img/my-adt-app.89cec4a4.png";